'use client';

import { useBunja } from 'bunja/react';
import { useState } from 'react';

import { SpinMachine, useSpinMachine } from '@flipster/features/src/contentful/lucky-draw/spin-machine';
import { luckyDrawBunja } from '@flipster/features/src/contentful/lucky-draw/state';
import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import { createSegmentedControl } from '@flipster/react/design-system/segmented-control';
import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';

const SegmentedControl = createSegmentedControl<string>();

export const Draws = () => {
  const { luckyDrawsLayout } = useBunja(luckyDrawBunja);
  const [selectedTab, setSelectedTab] = useState<string>(luckyDrawsLayout?.[0]?.slug ?? '');

  const { handleDraw, isRunning, disabled, ...machineProps } = useSpinMachine(selectedTab);

  if (!luckyDrawsLayout) return null;
  return (
    <div className={css({ textAlign: 'center' })}>
      <h2
        className={css({
          textStyle: 'Display/XL',
          color: 'content.default.level-5',
        })}
      >
        {luckyDrawsLayout[0]?.title}
      </h2>
      <p
        className={css({
          textStyle: 'Title/S',
          color: 'content.default.level-3',
          pt: { base: 12, tablet: 16 },
          pb: { base: 24, tablet: 40 },
        })}
      >
        {luckyDrawsLayout[0]?.description}
      </p>
      <SegmentedControl
        size='medium'
        value={selectedTab}
        onChange={setSelectedTab}
        css={{ w: 'fit-content', mx: 'auto' }}
      >
        {luckyDrawsLayout.map((item) => (
          <SegmentedControl.Item key={item.slug} value={item.slug ?? ''}>
            {item.tokenIcon?.title ?? ''}
          </SegmentedControl.Item>
        ))}
      </SegmentedControl>
      <div className={vstack({ gap: { base: 20, tablet: 16 }, pt: { base: 20, tablet: 32 } })}>
        <SpinMachine isRunning={isRunning} {...machineProps} />
        <Button
          hierarchy='primary'
          color='accent'
          size='large'
          label={<FormattedMessage id='Campaign.r251124.Pick_your_reward' />}
          onClick={() => handleDraw()}
          isLoading={isRunning}
          disabled={disabled}
          withSpinner
        />
      </div>
    </div>
  );
};
